/* const colors = {
  primary1: '#031F40',  // Dark blue
  primary2: '#ffb925',  // Green
  secondary1: '#C017A2',  // Fuchia
  secondary2: '#722282',  // Purple
  background: 'white',
  text: '#2a2a2a',
} */

export const theme = {
  border: {
    radius: {
      base: '10px',
      sm: '5px',
      md: '15px',
      lg: '20px',
    },
    width: {
      sm: '1px',
      md: '2px',
    },
    style: {
      solid: 'solid'
    }
  },
  spacing: {
    largeLateral: '10%',
    smallLateral: '3%',
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    section: '5rem',
  },
  typography: {
    fontSize: {
      base: '18px',
      s1: '3rem',
      s2: '2.5rem',
      s3: '2.0rem',
      s4: '1.6rem',
      s5: '1.2rem',
      s6: '1rem',
      s7: '0.8rem',
      title: '3.5rem',
      bigTitle: '4.5rem', 
    },
    fontWeight: {
      regular: 300,
      medium: 400,
      bold: 700,
    },
  },
  colors: {
    primary1: '#031F40',  // Dark blue
    primary2: '#4A9462',  // Green
    secondary1: '#C017A2',  // Fuchia
    secondary2: '#722282',  // Purple
    light: 'white',
    dark: 'black',
    dark2: '#404040',
    light2: '#fbfaf9',
    light3: '#a0a0ba',

  }
};
